<template>
  <div>
    <pt-modal
      ref="unavailabilityModal"
      :close-on-outside-click="false"
      size="large"
      no-border
      class="custom-modal unavailability-modal"
    >
      <div slot="modal-header" class="flex justify-between text-xl">
        <div class="">
          Turn Off Item Availability
        </div>
        <div>
          <button @click="close">
            <i class="fa fa-times" aria-hidden="true" />
          </button>
        </div>

      </div>
      <div slot="modal-body">
        <div>
          <div
            slot="form-group-label"
            for="item"
            class="text-grey-darker text-sm font-bold mb-1"
          >
            Item
          </div>
          <div class="text-red text-sm font-bold">
            {{ item ? item.name : '' }}
          </div>
        </div>
        <div class="mt-4">
          <pt-form-group :invalid-feedback="formErrors.invalid_duration">
            <div
              slot="form-group-label"
              for="duration-selector"
              class="text-black-darker text-sm font-bold mb-1"
            >
              How Long will the item be unavailable?
            </div>
            <pt-radio-group
              v-model="selectedValue"
              :options="durationOptions"
              :is-horizontal="false"
              name="duration-selector"
              @customDurationChanged="onCustomDurationChanged"
            />
          </pt-form-group>
        </div>
      </div>
      <div slot="modal-footer">
        <div class="flex w-full sm:flex-col md:flex-row md:justify-left">
          <pt-button
            :disabled="isLoading || !isSubmittable"
            class="sm:w-full md:w-auto md:px-4 my-1 mr-1"
            variant="primary"
            @action="submit"
          >
            Make Unavailable
          </pt-button>
          <pt-button
            :disabled="isLoading"
            class="sm:w-full md:w-auto md:px-4 my-1"
            variant="secondary-outline"
            @action="close"
          >
            Cancel
          </pt-button>
        </div>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import { PtModal, PtForm } from '@pathao/ui-components';
import PtRadioGroup from '../global/Radio/RadioGroup.vue';
import { MENUS_MAKE_UNAVAILABLE_DURATION_OPTIONS } from '@src/constants';
export default {
  components: {
    PtModal,
    PtForm,
    PtRadioGroup,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedValue: null,
      customDuration: null,
      isLoading: false,
      durationOptions: MENUS_MAKE_UNAVAILABLE_DURATION_OPTIONS,
      indexOfCustomizableDuraion: null,
      isSubmitClicked: false,
    };
  },
  computed: {
    isSubmittable() {
      return (this.selectedValue >= 0 && this.selectedValue <= 1440);
    },
    formErrors() {
      const errors = {};
      if (!this.isSubmittable) {
        errors.invalid_duration = 'Please provide between 1-24 hours';
      }
      return errors;
    },
  },
  mounted() {
    this.selectedValue = this.durationOptions[0].value;
    this.indexOfCustomizableDuration = this.durationOptions.findIndex(element => element.isCustomized);
  },
  methods: {
    show() {
      this.$refs.unavailabilityModal.showModal();
      this.isSubmitClicked = false;
    },
    close() {
      this.$emit('onUnavailability', !this.isSubmitClicked ? false : this.selectedValue);
      this.resetValues();
      this.$refs.unavailabilityModal.closeModal();
    },
    onCustomDurationChanged(duration) {
      this.selectedValue = this.durationOptions[this.indexOfCustomizableDuration].value = parseInt(duration) * 60;
    },
    resetValues() {
      this.durationOptions[this.indexOfCustomizableDuration].value = 60;
      this.selectedValue = this.durationOptions[0].value;
    },
    submit() {
      this.isSubmitClicked = true;
      this.close();
    },
  },

};
</script>
